/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreasRequest
 */
export interface BulkImportFacilityServiceAreasRequest {
    /**
     * 
     */
    s3_key: string;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreasRequest interface.
 */
export function instanceOfBulkImportFacilityServiceAreasRequest(value: object): value is BulkImportFacilityServiceAreasRequest {
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function BulkImportFacilityServiceAreasRequestFromJSON(json: any): BulkImportFacilityServiceAreasRequest {
    return BulkImportFacilityServiceAreasRequestFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreasRequest {
    if (json == null) {
        return json;
    }
    return {
        
        's3_key': json['s3_key'],
    };
}

export function BulkImportFacilityServiceAreasRequestToJSON(json: any): BulkImportFacilityServiceAreasRequest {
    return BulkImportFacilityServiceAreasRequestToJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasRequestToJSONTyped(value?: BulkImportFacilityServiceAreasRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        's3_key': value['s3_key'],
    };
}

